import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/shared/http.service';
import { Observable } from 'rxjs';
import { ErrorMessage } from '../interfaces/error-message.interface';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {

  constructor(private httpService: HttpService) { }


  public getErrorMessages(from: string, to?: string, samId?: number, groupId?: number, projectId?: number, errorType?: number, errorLevel?: number): Observable<ErrorMessage[]> {
    return this.httpService.post('ErrorMessage/getErrorMessages', { from, to, samId, groupId, projectId, errorType, errorLevel });
  }

  /* only for testing */
  public createErrorMessage(ErrorMessage: ErrorMessage): any {
    return this.httpService.post('ErrorMessage/createErrorMessage', ErrorMessage);
  }

}
